// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background: transparent;
}

.venue-item {
  border-radius: 0;
  background: var(--background-color);
  box-shadow: 0px 3.09px 11.57px 0px rgba(79, 97, 79, 0.1490196078);
  transition: 0.3s linear;
  text-align: left;
  margin-bottom: 10px;
  border-radius: 10px;
  margin-top: 10px;
  position: relative;
  padding: 5px;
  width: 100%;
}
.venue-item .info_icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 999;
  zoom: 1.3;
}
.venue-item.selected {
  transition: 0.3s linear;
  background: white;
  color: white;
}
.venue-item p {
  margin: 0;
}
.venue-item .name {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  margin-bottom: 1px;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  margin-right: 25px;
}
.venue-item .address {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: black;
}

.right-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.info-block {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.info-block .icon {
  height: 22px;
  width: 22px;
}
.info-block .icon:first-child {
  margin-right: 3.5px;
}
.info-block .icon ion-icon {
  width: 100%;
  height: 100%;
}

.open-block {
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
}
.open-block .label-open {
  width: 60px;
  height: 15px;
  border-radius: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #db052c;
  color: white;
  font-family: AppFont, sans-serif;
  font-size: 9px;
  line-height: 10px;
  letter-spacing: 0em;
  text-align: center;
}
.open-block .label-open ion-label {
  color: white;
  font-family: AppFontLight, sans-serif;
  font-size: 8px;
}
.open-block .label-open.enabled {
  background-color: #10843e;
}

.distance {
  height: 21px;
  min-width: 45px;
  padding: 2px 8px !important;
  text-align: center;
  margin-right: 5px;
}

.second-row {
  margin-top: 2px;
}

.app-logo {
  width: 60px;
  height: 35px;
  color: var(--ion-color-gold);
}
.app-logo.selected {
  color: white;
}

.wrap {
  padding-top: 10px;
}

a {
  height: 21px;
}

.box {
  color: var(--ion-color-main);
  border: 2px solid var(--ion-color-main);
  padding: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.box.selected {
  color: white;
  border: 2px solid white;
}

.venue-status {
  color: white;
  background: var(--ion-color-gold);
  border-radius: 2px;
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px 8px !important;
  min-width: 45px;
  text-align: center;
  margin-right: 5px;
}
.venue-status.selected {
  background: white;
  color: var(--ion-color-primary);
}

.preorder-type {
  --background: #f6f0eb;
  color: #9f9f9f;
  font-weight: bold;
  cursor: pointer;
  --padding: 16px;
  border-radius: 0;
  border: none !important;
  padding: 0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  margin: 0;
  --detail-icon-color: var(--ion-color-main);
  --detail-icon-opacity: 1;
}
.preorder-type.active {
  transition: 0.3s linear;
  --background: #f6f0eb;
  color: var(--ion-color-main);
}
.preorder-type h3 {
  font-family: AppFont-black, sans-serif;
  font-size: 14px;
}
.preorder-type p {
  color: var(--ion-color-primary);
  font-weight: 400;
}

.border-top {
  border-top: 0.5px solid #e8e8e8;
}

.align-center {
  text-align: center;
}

.button-separator {
  width: 3px;
  height: 100%;
}

.top-row {
  padding: 6px;
  min-height: 63px;
  position: relative;
}

.arrow-down {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  height: 6px;
  width: 10px;
  transition: opacity 0.3s ease-out;
}

.venue-item:has(.type_show) .arrow-down {
  opacity: 0;
}
.venue-item:has(.type_show) .separator--top {
  opacity: 0;
  margin: 0;
}

.small-margin-top {
  margin-top: 6px;
}

.top-end-img {
  position: absolute;
  top: 0;
  right: 0;
  height: 36px;
  width: 40px;
}

.type-col {
  padding: 11px;
}

.delivery-col {
  padding: 5px 11px 11px;
}

.item {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
}
.item .item-left-part {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.item .type-icon {
  height: 100%;
  margin-right: 8px;
  opacity: 0.3;
  transition: opacity 2s;
}
.item .item-type {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.06em;
  text-align: left;
  color: var(--ion-color-primary);
  opacity: 0.3;
  transition: opacity 2s;
  text-transform: uppercase;
}
.item .item-desc {
  font-family: AppFont;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
  opacity: 0.3;
  transition: opacity 2s;
}
.item .item-arrow {
  height: 100%;
  opacity: 0.3;
  transition: opacity 2s;
}
.item.active .type-icon {
  opacity: 1;
}
.item.active .item-arrow {
  opacity: 1;
}
.item.active .item-type {
  opacity: 1;
}
.item.active .item-type .item-desc {
  opacity: 1;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: opacity 0.3s ease-out, margin 0.5s ease-out;
}
.separator--top {
  margin-top: 15px;
  margin-bottom: 5px;
}
.separator .line {
  height: 8px;
  background-size: 7px 100%;
}

.delivery-col {
  position: relative;
}
.delivery-col .title-block {
  margin-bottom: 16px;
}
.delivery-col .title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.06em;
  text-align: left;
  color: #000;
  text-transform: uppercase;
}
.delivery-col .subtitle {
  font-family: AppFontLight;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: left;
}
.delivery-col .delivery-item {
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  opacity: 0.5;
}
.delivery-col .delivery-item.active {
  opacity: 1;
}
.delivery-col .arrow-up {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%) rotate(180deg);
  height: 6px;
  width: 10px;
}

.type-wrapper {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 0px;
  transition: max-height 1s;
  overflow: auto;
}
.type-wrapper.type_show {
  max-height: 800px;
}

.distance-block {
  padding-top: 5px;
  font-size: 10px;
  color: #000;
  font-family: AppFontLight, sans-serif;
  text-align: right;
}

.time-open {
  padding-top: 5px;
  font-size: 10px;
  font-family: AppFontBold;
  color: black;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-suggestion/venue-suggestion.component.scss"],"names":[],"mappings":"AAAA;EACC,uBAAA;AACD;;AACA;EACC,gBAAA;EACA,mCAAA;EACA,iEAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAED;AADC;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;AAGF;AADC;EACC,uBAAA;EACA,iBAAA;EAEA,YAAA;AAEF;AACC;EACC,SAAA;AACF;AAEC;EACC,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;AAAF;AAGC;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,YAAA;AAFF;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;AAHD;;AAMA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAHD;AAKC;EACC,YAAA;EACA,WAAA;AAHF;AAKE;EACC,mBAAA;AAHH;AAKE;EACC,WAAA;EACA,YAAA;AAHH;;AAOA;EACC,aAAA;EACA,yBAAA;EACA,gBAAA;AAJD;AAKC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAIE;EACC,YAAA;EACA,qCAAA;EACA,cAAA;AAFH;AAIE;EACC,yBAAA;AAFH;;AAOA;EACC,YAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AAJD;;AAOA;EACC,eAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;EACA,4BAAA;AAJD;AAMC;EACC,YAAA;AAJF;;AAQA;EACC,iBAAA;AALD;;AAQA;EACC,YAAA;AALD;;AAQA;EACC,4BAAA;EACA,uCAAA;EACA,YAAA;EACA,0CAAA;AALD;AAOC;EACC,YAAA;EACA,uBAAA;AALF;;AASA;EACC,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAND;AAQC;EACC,iBAAA;EACA,+BAAA;AANF;;AAUA;EACC,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;EACA,SAAA;EACA,0CAAA;EACA,wBAAA;AAPD;AASC;EACC,uBAAA;EACA,qBAAA;EACA,4BAAA;AAPF;AAUC;EACC,sCAAA;EACA,eAAA;AARF;AAWC;EACC,+BAAA;EACA,gBAAA;AATF;;AAaA;EACC,+BAAA;AAVD;;AAaA;EACC,kBAAA;AAVD;;AAaA;EACC,UAAA;EACA,YAAA;AAVD;;AAaA;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;AAVD;;AAaA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;AAVD;;AAcC;EACC,UAAA;AAXF;AAcC;EACC,UAAA;EACA,SAAA;AAZF;;AAgBA;EACC,eAAA;AAbD;;AAgBA;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAbD;;AAgBA;EACC,aAAA;AAbD;;AAgBA;EACC,sBAAA;AAbD;;AAgBA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EAEA,eAAA;AAdD;AAeC;EACC,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAbF;AAgBC;EACC,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAdF;AAoBC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;AAlBF;AAqBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAnBF;AAsBC;EACC,YAAA;EACA,YAAA;EACA,sBAAA;AApBF;AAwBE;EACC,UAAA;AAtBH;AAwBE;EACC,UAAA;AAtBH;AAwBE;EACC,UAAA;AAtBH;AAwBG;EACC,UAAA;AAtBJ;;AA4BA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uDAAA;AAzBD;AA2BC;EACC,gBAAA;EACA,kBAAA;AAzBF;AA4BC;EACC,WAAA;EAEA,yBAAA;AA3BF;;AA+BA;EACC,kBAAA;AA5BD;AA6BC;EACC,mBAAA;AA3BF;AA6BC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AA3BF;AA6BC;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA3BF;AA8BC;EACC,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA5BF;AA6BE;EACC,UAAA;AA3BH;AA+BC;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,0CAAA;EACA,WAAA;EACA,WAAA;AA7BF;;AAgCA;EACC,wBAAA;EAAA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AA7BD;AA8BC;EACC,iBAAA;AA5BF;;AAgCA;EACC,gBAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;EACA,iBAAA;AA7BD;;AA+BA;EACC,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;AA5BD","sourcesContent":["button {\n\tbackground: transparent;\n}\n.venue-item {\n\tborder-radius: 0;\n\tbackground: var(--background-color);\n\tbox-shadow: 0px 3.09px 11.57px 0px #4F614F26;\n\ttransition: 0.3s linear;\n\ttext-align: left;\n\tmargin-bottom: 10px;\n\tborder-radius: 10px;\n\tmargin-top: 10px;\n\tposition: relative;\n\tpadding: 5px;\n\twidth: 100%;\n\t.info_icon {\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 5px;\n\t\tz-index: 999;\n\t\tzoom: 1.3;\n\t}\n\t&.selected {\n\t\ttransition: 0.3s linear;\n\t\tbackground: white;\n\n\t\tcolor: white;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t}\n\n\t.name {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 16px;\n\t\tline-height: 19px;\n\t\ttext-align: left;\n\t\tmargin-bottom: 1px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin-right: 25px;\n\t}\n\n\t.address {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 15px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\n\t\tcolor: black;\n\t}\n}\n\n.right-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.info-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t.icon {\n\t\theight: 22px;\n\t\twidth: 22px;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 3.5px;\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n.open-block {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding-top: 5px;\n\t.label-open {\n\t\twidth: 60px;\n\t\theight: 15px;\n\t\tborder-radius: 45px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground-color: #db052c;\n\t\tcolor: white;\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: center;\n\t\tion-label {\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFontLight, sans-serif;\n\t\t\tfont-size: 8px;\n\t\t}\n\t\t&.enabled {\n\t\t\tbackground-color: #10843e;\n\t\t}\n\t}\n}\n\n.distance {\n\theight: 21px;\n\tmin-width: 45px;\n\tpadding: 2px 8px !important;\n\ttext-align: center;\n\tmargin-right: 5px;\n}\n\n.second-row {\n\tmargin-top: 2px;\n}\n\n.app-logo {\n\twidth: 60px;\n\theight: 35px;\n\tcolor: var(--ion-color-gold);\n\n\t&.selected {\n\t\tcolor: white;\n\t}\n}\n\n.wrap {\n\tpadding-top: 10px;\n}\n\na {\n\theight: 21px;\n}\n\n.box {\n\tcolor: var(--ion-color-main);\n\tborder: 2px solid var(--ion-color-main);\n\tpadding: 2px;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\n\t&.selected {\n\t\tcolor: white;\n\t\tborder: 2px solid white;\n\t}\n}\n\n.venue-status {\n\tcolor: white;\n\tbackground: var(--ion-color-gold);\n\tborder-radius: 2px;\n\tfont-size: 13px;\n\twidth: fit-content;\n\tpadding: 2px 8px !important;\n\tmin-width: 45px;\n\ttext-align: center;\n\tmargin-right: 5px;\n\n\t&.selected {\n\t\tbackground: white;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.preorder-type {\n\t--background: #f6f0eb;\n\tcolor: #9f9f9f;\n\tfont-weight: bold;\n\tcursor: pointer;\n\t--padding: 16px;\n\tborder-radius: 0;\n\tborder: none !important;\n\tpadding: 0;\n\tbox-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tmargin: 0;\n\t--detail-icon-color: var(--ion-color-main);\n\t--detail-icon-opacity: 1;\n\n\t&.active {\n\t\ttransition: 0.3s linear;\n\t\t--background: #f6f0eb;\n\t\tcolor: var(--ion-color-main);\n\t}\n\n\th3 {\n\t\tfont-family: AppFont-black, sans-serif;\n\t\tfont-size: 14px;\n\t}\n\n\tp {\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 400;\n\t}\n}\n\n.border-top {\n\tborder-top: 0.5px solid #e8e8e8;\n}\n\n.align-center {\n\ttext-align: center;\n}\n\n.button-separator {\n\twidth: 3px;\n\theight: 100%;\n}\n\n.top-row {\n\tpadding: 6px;\n\tmin-height: 63px;\n\tposition: relative;\n}\n\n.arrow-down {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\theight: 6px;\n\twidth: 10px;\n\ttransition: opacity 0.3s ease-out;\n}\n\n.venue-item:has(.type_show) {\n\t.arrow-down {\n\t\topacity: 0;\n\t}\n\n\t.separator--top {\n\t\topacity: 0;\n\t\tmargin: 0;\n\t}\n}\n\n.small-margin-top {\n\tmargin-top: 6px;\n}\n\n.top-end-img {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\theight: 36px;\n\twidth: 40px;\n}\n\n.type-col {\n\tpadding: 11px;\n}\n\n.delivery-col {\n\tpadding: 5px 11px 11px;\n}\n\n.item {\n\twidth: 100%;\n\theight: 30px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 16px;\n\n\tcursor: pointer;\n\t.item-left-part {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t}\n\n\t.type-icon {\n\t\theight: 100%;\n\t\tmargin-right: 8px;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t.item-info {\n\t}\n\n\t.item-type {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary);\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.item-desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t.item-arrow {\n\t\theight: 100%;\n\t\topacity: 0.3;\n\t\ttransition: opacity 2s;\n\t}\n\n\t&.active {\n\t\t.type-icon {\n\t\t\topacity: 1;\n\t\t}\n\t\t.item-arrow {\n\t\t\topacity: 1;\n\t\t}\n\t\t.item-type {\n\t\t\topacity: 1;\n\n\t\t\t.item-desc {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\ttransition: opacity 0.3s ease-out, margin .5s ease-out;\n\n\t&--top {\n\t\tmargin-top: 15px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.line {\n\t\theight: 8px;\n\t\t// background-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n}\n\n.delivery-col {\n\tposition: relative;\n\t.title-block {\n\t\tmargin-bottom: 16px;\n\t}\n\t.title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t\ttext-transform: uppercase;\n\t}\n\t.subtitle {\n\t\tfont-family: AppFontLight;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t}\n\n\t.delivery-item {\n\t\theight: 28px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\t\topacity: 0.5;\n\t\t&.active {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t.arrow-up {\n\t\tposition: absolute;\n\t\tbottom: 10px;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%) rotate(180deg);\n\t\theight: 6px;\n\t\twidth: 10px;\n\t}\n}\n.type-wrapper {\n\theight: fit-content;\n\tmax-height: 0px;\n\ttransition: max-height 1s;\n\toverflow: auto;\n\t&.type_show {\n\t\tmax-height: 800px;\n\t}\n}\n\n.distance-block {\n\tpadding-top: 5px;\n\tfont-size: 10px;\n\tcolor: #000;\n\tfont-family: AppFontLight, sans-serif;\n\ttext-align: right;\n}\n.time-open {\n\tpadding-top: 5px;\n\tfont-size: 10px;\n\tfont-family:AppFontBold ;\n\tcolor: black;\n\ttext-align: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
